import React, { useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { MainLayout } from "../../layout/MainLayout";
import useAuth from "../login/AuthContext";

import { ClosingReminder } from "./notifications/ClosingReminder";
import { PushTest } from "./notifications/PushTest";

export enum NotificationTypes {
  NONE,
  CLOSING_REMINDER,
  PUSH_TEST,
}

export const NotificationTestContainer = () => {
  const { isWriteAccess } = useAuth();
  const [notification, setNotification] = useState<number>(NotificationTypes.NONE);

  return (
    <MainLayout title="Notification Test">
      {isWriteAccess() && (
        <>
          <Dropdown
            placeholder="Select notificationType"
            onChange={(e, data) => {
              setNotification(data.value as number);
            }}
            selection
            options={[
              {
                key: "closingReminder",
                text: "Closing Reminder",
                value: NotificationTypes.CLOSING_REMINDER,
              },
              {
                key: "pushTest",
                text: "Push",
                value: NotificationTypes.PUSH_TEST,
              },
            ]}
          />

          <NotificationSelector notificationType={notification} />
        </>
      )}
    </MainLayout>
  );
};

interface NotificationSelectorProps {
  notificationType: number;
}

const NotificationSelector: React.FunctionComponent<NotificationSelectorProps> = ({ notificationType }) => {
  let display = <div>None Selected</div>;

  switch (notificationType as NotificationTypes) {
    case NotificationTypes.PUSH_TEST:
      display = <PushTest />;
      break;
    case NotificationTypes.CLOSING_REMINDER:
      display = <ClosingReminder />;
      break;
  }

  return display;
};
